import Sidebar from "../Sidebar";
import Header from "../Header";
import { Link, Outlet } from "react-router-dom";
import logo from "../../assets/logo.png";
import { useEffect, useRef, useState } from "react";
import Footer from "../Footer";

type Props = {};

const BaseLayout = (props: Props) => {
  const [sidebarOpen, setSidebarOpen] = useState<boolean>(false);
  const sidebar = useRef<any>(null);
  const trigger1 = useRef<any>(null);
  const trigger2 = useRef<any>(null);

  // close on click outside
  useEffect(() => {
    const clickHandler = (event: any) => {
      if (!sidebar.current || !trigger1.current || !trigger2.current) return;
      if (
        !sidebarOpen ||
        sidebar.current.contains(event.target) ||
        trigger1.current.contains(event.target) ||
        trigger2.current.contains(event.target)
      )
        return;
      setSidebarOpen(false);
    };
    document.addEventListener("click", clickHandler);
    return () => document.removeEventListener("click", clickHandler);
  });

  return (
    <>
      <div className="flex h-screen bg-gray bg-opacity-10 dark:bg-blacklight ">
        {/* <div className="hidden md:flex flex-col w-64 bg-gray-800"> */}
        <div
          ref={sidebar}
          className={`absolute left-0 top-0 z-9999 flex h-screen w-56 flex-col overflow-y-hidden bg-white duration-300 ease-linear dark:bg-boxdark lg:static lg:translate-x-0 ${sidebarOpen
              ? "translate-x-0"
              : "-translate-x-full lg:block sm:hidden"
            }`}
        >
          <div className="border-r   flex items-center p-2 md:justify-center xs:justify-between h-16 bg-white dark:bg-dark">
            <div className="mt-2 text-xs text-gray-600 dark:text-gray-300 text-center">
              <p>
                For more visit {" "}
                <a
                  href="https://globalprotectioncluster.org/AoR/HLP"
                  className="text-[#EA580C] underline hover:text-[#C2410C] transition-colors"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  Global HLP AoR
                </a>
              </p>
            </div>
            {sidebarOpen && (
              <button
                ref={trigger1}
                onClick={() => setSidebarOpen(false)}
                className="text-graylight focus:outline-none focus:text-gray-700 text-lg"
              >
                <svg className="h-6 w-6 fill-current" viewBox="0 0 24 24">
                  <path
                    fillRule="evenodd"
                    d="M18.278 16.864a1 1 0 0 1-1.414 1.414l-4.829-4.828-4.828 4.828a1 1 0 0 1-1.414-1.414l4.828-4.829-4.828-4.828a1 1 0 0 1 1.414-1.414l4.829 4.828 4.828-4.828a1 1 0 1 1 1.414 1.414l-4.828 4.829 4.828 4.828z"
                  />
                </svg>
              </button>
            )}
          </div>
          <div className="flex flex-col flex-1 overflow-y-auto bg-orange">
            <Sidebar />
          </div>
        </div>

        <div className="flex flex-col flex-1 overflow-y-auto">
          <Header
            trigger2={trigger2}
            sidebarOpen={sidebarOpen}
            setSidebarOpen={setSidebarOpen}
          />
          <div className="dark:bg-blacklight ">
            <div className="p-4 min-h-[90vh]">
              <Outlet />
            </div>
            <div className="mx-auto w-full">

              <Footer />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BaseLayout;
